<template>
  <div>
    <v-container grid-list-xl fluid class="px-8 py-4">
      <div class="mb-3">
        <h1 class="fs-18 lh-18 text-uppercase mt-1 font-weight-700">
          RE-REOUTE REQUEST
        </h1>
        <v-breadcrumbs class="px-0 py-2" :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <v-row no-gutters align="center" justify="space-between" class="mb-3">
        <v-col cols="12" sm="6">
          <h1 class="fs-20 font-weight-bold bluedarken--text">
            Re-Route Request by User
          </h1>
        </v-col>
      </v-row>
      <v-card class="elevation-card rounded-10" :loading="loading">
        <v-card-title class="mb-3">
          <v-row no-gutters align="center">
            <v-col cols="12">
              <span
                class="mb-1 d-block fs-12 font-weight-bold fs-14"
                for="search"
              >
                Find user to re-route
              </span>
            </v-col>
            <v-col sm="4" class="mr-2">
              <v-autocomplete
                id="search"
                placeholder="Search user..."
                single-line
                dense
                outlined
                v-model="user"
                autocomplete="none"
                :items="users"
                return-object
                item-text="user.name"
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="auto" class="pl-1">
              <v-btn
                class="btn-medium"
                depressed
                color="menuActive"
                dark
                @click="searchRequest()"
              >
                Search
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-col class="text-right px-0">
            <v-btn
              class="btn-medium"
              depressed
              color="menuActive"
              :dark="selected.length > 1"
              :disabled="selected.length < 2"
              :filled="selected.length < 2"
              @click="openDialog('batch', null)"
            >
              Batch Re-Route
            </v-btn>
          </v-col>
          <v-simple-table
            fixed-header
            class="spending-table nav-table sshcf-table"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th width="41px" style="padding: 0px 17px !important;">
                    <v-layout
                      align-center
                      style="margin-top:-5px;margin-left:-3px"
                    >
                      <label class="form-checkbox">
                        <input
                          class="checkbox-approval"
                          type="checkbox"
                          v-model="selectAll"
                          @click="selectAllData"
                        />
                        <span class="checkbox-custom"></span>
                      </label>
                    </v-layout>
                  </th>
                  <template v-for="header in headers">
                    <th
                      :key="header.text"
                      class="white--text"
                      :class="{
                        [`text-${header.align}`]: true,
                        [header.customClass]: !!header.customClass
                      }"
                    >
                      <span>{{ header.text }}</span>
                    </th>
                  </template>
                </tr>
              </thead>
              <VuePerfectScrollbar
                class="drawer-menu--scroll"
                :settings="scrollSettings"
              >
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td
                      width="41px"
                      style="border-left: 1px solid rgb(230, 230, 230) !important; border-bottom: 1px solid rgb(230, 230, 230) !important"
                    >
                      <v-layout
                        align-center
                        style="margin-top:-5px;margin-left:-3px"
                      >
                        <label class="form-checkbox">
                          <input
                            class="checkbox-approval"
                            type="checkbox"
                            :value="item.id"
                            v-model="selected"
                          />
                          <span class="checkbox-custom"></span>
                        </label>
                      </v-layout>
                    </td>
                    <template v-for="header in headers">
                      <td
                        :key="header.name"
                        :class="{
                          [header.tdClass]: true,
                          [`text-${header.align}`]: true,
                          [header.tdClass]: !!header.tdClass
                        }"
                      >
                        <template v-if="header.value === 'action'">
                          <v-btn
                            text
                            class="bluedarken--text btn-medium"
                            @click="openDialog('single', item)"
                          >
                            Re-Route
                          </v-btn>
                          <v-btn
                            text
                            class="bluedarken--text btn-medium"
                            @click="getDetail(item.form_request_id)"
                          >
                            Progress Tracking
                          </v-btn>
                        </template>
                        <template v-if="header.value === 'unique_code'">
                          {{ item.formRequest.unique_code }}
                        </template>
                        <span>
                          {{ header | tableRowValue(item) }}
                        </span>
                      </td>
                    </template>
                  </tr>
                  <tr v-if="!items.length">
                    <td :colspan="headers.length" class="text-center">
                      {{ loading ? 'Loading...' : 'No data available' }}
                    </td>
                  </tr>
                </tbody>
              </VuePerfectScrollbar>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="showDialog" id="showDialog" persistent max-width="600px">
      <v-card class="rounded-10">
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-0">
            <v-card-title
              class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6 rounded-top-left-10 rounded-top-right-10"
            >
              <span class="pa-0">
                Change Approver -
                {{ isBatch ? 'Batch' : item.formRequest.unique_code }}
              </span>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-row align="center">
                <v-col sm12>
                  <ValidationProvider
                    name="Name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>From</label>
                    <v-text-field
                      single-line
                      outlined
                      v-model="item.user_name"
                      placeholder="Name"
                      required
                      filled
                      disabled
                      :error-messages="errors"
                      dense
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    slim
                    name="User"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="user" class="fs-12 font-weight-regular mb-1">
                      To
                    </label>
                    <v-autocomplete
                      id="user"
                      placeholder="User"
                      single-line
                      v-model="new_approver"
                      return-object
                      item-text="user.name"
                      dense
                      outlined
                      :error-messages="errors"
                      :items="users"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pb-6 px-6">
              <v-spacer></v-spacer>
              <v-btn
                color="#bd1e19"
                dark
                @click="closeDialog()"
                class="btn-medium px-4"
              >
                Close
              </v-btn>
              <v-btn
                color="primary"
                class="btn-medium px-4"
                dark
                type="submit"
                :loading="loadingSubmit"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="900px">
      <card-progress-tracking
        v-if="progressTracking"
        :loading="loadingDetail"
        :steps="steps"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatDate } from '@/utils/helpers';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '@/mixins/ACLMixin';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CardProgressTracking from '@/components/SSHCP/CardProgressTracking';

export default {
  components: {
    VuePerfectScrollbar,
    CardProgressTracking
  },
  mixins: [ACLMixin],
  data() {
    return {
      progressDialogLoading: false,
      scrollSettings: {
        maxScrollbarLength: 340
      },
      loading: false,
      breadcrumbs: [
        {
          text: 'Re-Route',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Request',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      // itemsPerPage: 10,
      timeout: null,
      showDialog: false,
      dialog: false,
      user: '',
      new_approver: '',
      users: [],
      headers: [
        {
          text: 'HCP Code',
          align: 'left',
          value: 'unique_code'
        },
        {
          text: 'Pending Approval',
          align: 'left',
          value: 'user_name',
          tdClass: 'text-capitalize'
        },
        {
          text: 'Action',
          align: 'center',
          value: 'action'
        }
      ],
      items: [],
      item: {
        id: '',
        user_name: '',
        formRequest: {
          unique_code: ''
        }
      },
      selectAll: false,
      selected: [],
      loadingDetail: false,
      isBatch: false,
      loadingSubmit: false
    };
  },
  watch: {
    descending() {
      // this.getData();
    },
    selected(val) {
      if (val.length === this.items.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    }
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState('sshcp', {
      progressTracking: 'progressTracking'
    }),
    steps() {
      return this.progressTracking.map(item => {
        let itemApproved = item.find(val => val.approval_date !== null);
        return {
          group_name: item[0].group_name,
          email: item.map(val => val.email.toLowerCase()),
          name: item.map(val => {
            return {
              name: val.user_name,
              isApproved: !!val.approval_date
            };
          }),
          complete: itemApproved?.status === 'approved',
          date: itemApproved ? formatDate(itemApproved.approval_date) : '',
          status: itemApproved?.status,
          notes: itemApproved?.notes
        };
      });
    }
  },
  methods: {
    getData() {
      this.loading = true;
      return this.$store
        .dispatch('sshcp/getUserApprover', {
          paginate: false
        })
        .then(data => {
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.users = data.data.users;
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    },
    searchRequest() {
      this.loading = true;
      return this.$store
        .dispatch('sshcp/getRequestApproval', this.user.user.id)
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    },
    save() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to re-route this form request?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result) {
          this.loadingSubmit = true;
          let request = [];
          if (!this.isBatch) request.push(this.item.id);
          let params = {
            form_approval_ids: this.isBatch ? this.selected : request,
            new_approver_id: this.new_approver.user.id,
            group_id: this.new_approver.group.id
          };
          return this.$store
            .dispatch('sshcp/requestReRoute', params)
            .then(data => {
              this.loadingSubmit = false;
              if (data.code === 200) {
                this.getData();
                this.items = [];
                this.isBatch = false;
                this.showDialog = false;
                this.user = '';
                this.selected = [];
                this.selectAll = false;
                Swal.fire('Success!', data.message.text_en, 'success');
              } else {
                Swal.fire('Failed!', data.message.text_en, 'error');
                this.loadingSubmit = false;
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.message.text_en, 'error');
              this.loadingSubmit = false;
            });
        }
      });
    },
    selectAllData() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.items) {
          this.selected.push(this.items[i].id);
        }
      }
    },
    openDialog(type, item) {
      if (type === 'batch') {
        this.isBatch = true;
        this.item.user_name = this.user.user.name;
      } else {
        this.isBatch = false;
        this.item = item;
      }
      this.showDialog = !this.showDialog;
    },
    closeDialog() {
      this.showDialog = false;
    },
    async getDetail(id) {
      this.dialog = true;
      this.loadingDetail = true;
      await this.$store.dispatch('sshcp/getProgressTracking', id);
      this.loadingDetail = false;
    }
  }
};
</script>

<style scoped>
.drawer-menu--scroll {
  max-height: 300px;
  overflow: auto;
}
</style>
